export type AtwMarkId =
  | "directory"
  | "one"
  | "mail"
  | "workspaces"
  | "hub"
  | "pay"
  | "agents"
  | "worksuite"
  | "platform"
  | "crm"
  | "finance"
  | "hr"
  | "marketing"
  | "knowledge"
  | "projects"
  | "analytics"
  | "support"
  | "custom-apps";

export type AtwMark = {
  id: AtwMarkId;
  name: string;
  kind: "system" | "app";
  src: string;
};

export const ATW_MARKS: AtwMark[] = [
  { id: "directory", name: "Directory", kind: "system", src: "/images/atw-marks/system-directory.svg" },
  { id: "one", name: "One", kind: "system", src: "/images/atw-marks/system-one.svg" },
  { id: "mail", name: "Mail", kind: "system", src: "/images/atw-marks/system-mail.svg" },
  { id: "workspaces", name: "WorkSuite", kind: "system", src: "/images/atw-marks/system-mail.svg" },
  { id: "hub", name: "Hub", kind: "system", src: "/images/atw-marks/system-hub.svg" },
  { id: "pay", name: "Pay", kind: "system", src: "/images/atw-marks/system-pay.svg" },
  { id: "agents", name: "Agents", kind: "system", src: "/images/atw-marks/system-agents.svg" },
  { id: "worksuite", name: "WorkSuite", kind: "system", src: "/images/atw-marks/system-worksuite.svg" },
  { id: "platform", name: "Platform", kind: "system", src: "/images/atw-marks/system-platform.svg" },
  { id: "crm", name: "CRM", kind: "app", src: "/images/atw-marks/app-crm.svg" },
  { id: "finance", name: "Finance", kind: "app", src: "/images/atw-marks/app-finance.svg" },
  { id: "hr", name: "HR", kind: "app", src: "/images/atw-marks/app-hr.svg" },
  { id: "marketing", name: "Marketing", kind: "app", src: "/images/atw-marks/app-marketing.svg" },
  { id: "knowledge", name: "Knowledge", kind: "app", src: "/images/atw-marks/app-knowledge.svg" },
  { id: "projects", name: "Projects", kind: "app", src: "/images/atw-marks/app-projects.svg" },
  { id: "analytics", name: "Analytics", kind: "app", src: "/images/atw-marks/app-analytics.svg" },
  { id: "support", name: "Support", kind: "app", src: "/images/atw-marks/app-support.svg" },
  { id: "custom-apps", name: "Custom apps", kind: "app", src: "/images/atw-marks/app-custom.svg" },
];

const BY_ID = new Map(ATW_MARKS.map((mark) => [mark.id, mark]));

export function atwMark(id: AtwMarkId): AtwMark {
  const mark = BY_ID.get(id);
  if (!mark) throw new Error(`Unknown ATW mark: ${id}`);
  return mark;
}

function isAtwMarkId(id: string): id is AtwMarkId {
  return BY_ID.has(id as AtwMarkId);
}

export function atwMarkIdForAppSlug(slug: string): AtwMarkId | null {
  if (slug === "human-resources") return "hr";
  if (slug === "custom-apps") return "custom-apps";
  return isAtwMarkId(slug) && atwMark(slug).kind === "app" ? slug : null;
}
